import React, { Component } from 'react';
import { Tag } from 'antd';
import constants from '../../constants/appConstants';
const CheckableTag = Tag.CheckableTag;

class FilterPosition extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='filter-component'>
        <strong>Positions: </strong>
        {constants.POSITIONS.map((tag) => (
          <CheckableTag
            key={tag}
            checked={this.props.pos.indexOf(tag) > -1}
            onChange={(checked) => this.props.handlePosChange(tag, checked)}>
            {tag}
          </CheckableTag>
        ))}
      </div>
    );
  }
}

export default FilterPosition;



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/FilterPosition.js